import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgGoToLeadmailer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10.76 8 4.681 3.103L20.231 8H10.76Zm10.74.37V17h-12l.002-.781h-1l-.002.778A1 1 0 0 0 9.5 18h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9.522a1 1 0 0 0-1 .998L8.52 9.09h1l.001-.711 5.64 3.738.274.181.275-.178 5.79-3.75Z"
      fill="#007AFF"
    />
    <path fill="#007AFF" d="M1.502 10.127h7v1h-7zm2 2h4v1h-4v-1Zm2 2h3v1h-3z" />
  </svg>
);
const Memo = memo(SvgGoToLeadmailer);
export default Memo;
